export default {
  all: 'Any',
}
